var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10C8.55228 10 9 10.4477 9 11Z",
    fill: "#011235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 4V6.25745C3.06506 6.35715 2.25 7.44163 2.25 8.6V13.4C2.25 14.6157 3.14772 15.75 4.42857 15.75H11.5714C12.8523 15.75 13.75 14.6157 13.75 13.4V8.6C13.75 7.44163 12.9349 6.35715 11.75 6.25746V4C11.75 3.00544 11.3549 2.05161 10.6517 1.34835C9.94839 0.645088 8.99456 0.25 8 0.25C7.00544 0.25 6.05161 0.645088 5.34835 1.34835C4.64509 2.05161 4.25 3.00544 4.25 4ZM8 1.75C7.40326 1.75 6.83097 1.98705 6.40901 2.40901C5.98705 2.83097 5.75 3.40326 5.75 4V6.25H10.25V4C10.25 3.40326 10.0129 2.83097 9.59099 2.40901C9.16903 1.98705 8.59674 1.75 8 1.75ZM4.42857 7.75H11.5714C11.8685 7.75 12.25 8.04838 12.25 8.6V13.4C12.25 13.9516 11.8685 14.25 11.5714 14.25H4.42857C4.13147 14.25 3.75 13.9516 3.75 13.4V8.6C3.75 8.04838 4.13147 7.75 4.42857 7.75Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e700e208560c7be1d28c6b45d8e6b97d.svg";
export { ForwardRef as ReactComponent };